/* src/app/ui/ui-wrapper/ui-wrapper.component.scss */
.ui {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  height: 100vh;
}
.ui .ui-content {
  flex: 1;
}
.ui app-sidebar {
  flex: 0 0 20rem;
  max-width: 20rem;
  height: 100vh;
  overflow-y: auto;
  background-color: #2e2e38;
}
.ui app-toolbar {
  flex: 0 0 6.25rem;
  max-width: 6.25rem;
  height: 100vh;
  overflow-y: auto;
  padding: 1.5rem 0.75rem 0 0.75rem;
  border-left: 0.0625rem solid rgba(46, 46, 56, 0.08);
}
/*# sourceMappingURL=ui-wrapper.component.css.map */
